import { useState } from "react";
import { useAuth } from "@/auth/AuthContext";
import { hiddenNavItems, roleLabel } from "@/auth/permissions";

export function RoleAccessBadge() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user) return null;

  const hidden = hiddenNavItems(user);
  const perms = user.permissions.length > 0 ? user.permissions : ["(default demo bundle)"];

  return (
    <div className="access-badge-wrap">
      <button type="button" className="access-badge" onClick={() => setOpen((value) => !value)}>
        Demo · {roleLabel(user)}
      </button>
      {open ? (
        <div className="access-badge-panel card">
          <strong>Signed in as {user.display_name}</strong>
          <p style={{ margin: "0.35rem 0", color: "var(--muted)", fontSize: "0.85rem" }}>{user.email}</p>
          <div style={{ fontSize: "0.8rem", marginTop: "0.5rem" }}>
            <div>
              <strong>Agency role:</strong> {user.role}
            </div>
            {user.legacy_reviewer_role ? (
              <div>
                <strong>Reviewer role:</strong> {user.legacy_reviewer_role}
              </div>
            ) : null}
          </div>
          <div style={{ marginTop: "0.75rem" }}>
            <strong style={{ fontSize: "0.8rem" }}>Permissions</strong>
            <div className="access-chip-row">
              {perms.map((perm) => (
                <span key={perm} className="access-chip">
                  {perm}
                </span>
              ))}
            </div>
          </div>
          {hidden.length > 0 ? (
            <div style={{ marginTop: "0.75rem" }}>
              <strong style={{ fontSize: "0.8rem" }}>Hidden navigation</strong>
              <ul className="access-hidden-list">
                {hidden.map((item) => (
                  <li key={item.path}>
                    <span>{item.label}</span>
                    <span className="access-reason">{item.reason}</span>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <p style={{ marginTop: "0.75rem", fontSize: "0.8rem", color: "var(--muted)" }}>
              Full navigation visible for this role.
            </p>
          )}
        </div>
      ) : null}
    </div>
  );
}
